export const getRecentProjects = () => JSON.parse(localStorage.getItem('recentProjects')) || [];

export const addRecentProject = projectNumber => {
	let recentProjects = JSON.parse(localStorage.getItem('recentProjects'));
	recentProjects = Array.isArray(recentProjects) ? recentProjects : [];
	recentProjects = new Set(recentProjects.reverse());

	if (recentProjects.has(projectNumber)) {
		recentProjects.delete(projectNumber);
	}

	recentProjects.add(projectNumber);
	recentProjects = Array.from(recentProjects.values()).reverse();

	while (recentProjects.length > 3) {
		recentProjects.pop();
	}

	localStorage.setItem('recentProjects', JSON.stringify(recentProjects));
};
